module.exports = __webpack_public_path__ + "img/full6-min.d2c5ec97.png";